export const getSidePanelMatchUrl = (url?: string) => {
  if (!url) {
    return '';
  }
  if (url.at(-1) === '/') {
    return url.slice(0, -1);
  }
  return url;
};
